import { Component, h, Prop, Element, Host } from '@stencil/core';

/**
 * COMPNAME is for creating a container for the title of a Journal Article. Optionally, the component can display the Department Name and Subtitle (if applicable).
 */
@Component({
  tag: 'aafp-journal-article-title-and-kicker',
  shadow: false,
})
export class AafpJournalArticleTitleAndKicker {
  /**
   * For the article's title
   */
  @Prop() articleTitle!: string;

  /**
   * For the article title's link
   */
  @Prop() articleTitleLink: string;

  /**
   * For the department name
   */
  @Prop() departmentName: string;

  /**
   * For the department name's link
   */
  @Prop() departmentNameLink: string;

  /**
   * For the department subtitle
   */
  @Prop() departmentSubtitle: string;

  @Element() element: HTMLElement;

  render() {
    return (
      <Host>
        {this.departmentName && this.departmentNameLink && (
          <p class="adl-subtitle1">
            <a href={this.departmentNameLink}>{this.departmentName}</a>
          </p>
        )}
        {this.departmentName && !this.departmentNameLink && <p class="adl-subtitle1">{this.departmentName}</p>}
        {this.departmentSubtitle && <p class="adl-subtitle2">{this.departmentSubtitle}</p>}
        <h1 class="adl-h1">
          {this.articleTitleLink ? <a href={this.articleTitleLink}>{this.articleTitle}</a> : this.articleTitle}
        </h1>
      </Host>
    );
  }
}
